import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  hideWithStyle(el) {
    if (el) el.style.setProperty("display", "none", "important")
  }

  showWithStyle(el) {
    if (el) el.style.removeProperty("display")
  }

  openEdit(event) {
    event.preventDefault()
    const sqid = event.currentTarget.dataset.scheduleOpenEditSqid
    if (!sqid) return

    this.resetAllEdits()
    this.closeAddUi()

    this.element.querySelectorAll(`[data-schedule-activity-pair][data-schedule-activity-sqid="${sqid}"]`).forEach((pair) => {
      const showEl = pair.querySelector("[data-schedule-activity-show]")
      const editEl = pair.querySelector("[data-schedule-activity-edit]")
      this.hideWithStyle(showEl)
      this.showWithStyle(editEl)
    })
  }

  cancelEdit(event) {
    event.preventDefault()
    const pair = event.currentTarget.closest("[data-schedule-activity-pair]")
    if (!pair) return

    const sqid = pair.dataset.scheduleActivitySqid
    if (!sqid) return

    this.element.querySelectorAll(`[data-schedule-activity-pair][data-schedule-activity-sqid="${sqid}"]`).forEach((p) => {
      const showEl = p.querySelector("[data-schedule-activity-show]")
      const editEl = p.querySelector("[data-schedule-activity-edit]")
      this.showWithStyle(showEl)
      this.hideWithStyle(editEl)
    })
  }

  openAdd(event) {
    event.preventDefault()
    this.resetAllEdits()
    const trigger = this.element.querySelector("[data-schedule-add-trigger]")
    const forms = this.element.querySelector("[data-schedule-add-forms]")
    this.hideWithStyle(trigger)
    this.showWithStyle(forms)
  }

  cancelAdd(event) {
    event.preventDefault()
    const trigger = this.element.querySelector("[data-schedule-add-trigger]")
    const forms = this.element.querySelector("[data-schedule-add-forms]")
    this.showWithStyle(trigger)
    this.hideWithStyle(forms)
  }

  resetAllEdits() {
    this.element.querySelectorAll("[data-schedule-activity-pair]").forEach((pair) => {
      const showEl = pair.querySelector("[data-schedule-activity-show]")
      const editEl = pair.querySelector("[data-schedule-activity-edit]")
      this.showWithStyle(showEl)
      this.hideWithStyle(editEl)
    })
  }

  closeAddUi() {
    const trigger = this.element.querySelector("[data-schedule-add-trigger]")
    const forms = this.element.querySelector("[data-schedule-add-forms]")
    this.showWithStyle(trigger)
    this.hideWithStyle(forms)
  }
}
